export default __webpack_public_path__ + "static/media/david-beccarini-2.d1692587.webp";